<template>
    <main id="review">
      <!-- Banner Section -->
      <BannerButton :bannerDataProp="bannerData" />

      <h1 class="hidden-title" style="display: none" v-if="pageTitle && ! bannerData?.title">{{ pageTitle }}</h1>
      <!-- Main Reviews Section -->
      <div class="reviews-item">
        <div class="container">
          <div class="reviews-heading">
            <!-- <h3>Our Reviews</h3> -->
            <Heading
            level="2"
            >
            Our Reviews
            </Heading>
          </div>
          <div
            id="stamped-reviews-widget"
            data-widget-type="full-page"
            data-take="15"
            data-style-color-star="#c60c46"
            data-style-color-verified="#c60c46"
            data-style-color-text="#212529"
            data-style-color-link="#212529"
          ></div>
        </div>
      </div>
      <!-- Gallery Reviews Section -->
      <section class="sdj-gallery">
        <div class="wrapper-gallery display_flex">
          <!-- Left Gallery for Desktop -->
          <div class="box-gallery display_flex box-gallery-pc">
            <img v-for="(image, index) in leftGallery" :key="index" :src="image.url" alt="Gallery" />
          </div>

          <!-- Left Gallery for Mobile -->
          <div class="box-gallery box-gallery-mobile">
            <img v-if="leftGalleryMobile" :src="leftGalleryMobile" alt="Gallery" />
          </div>

          <!-- Social Sharing Section -->
          <div class="box-gallery gallery-social">
            <div class="inner-share">
              <div class="hash_tag">Tag us @skjewellery_malaysia to be featured</div>
              <Heading
              level="4"
              :style="{ color: '#FFF' }"
              >
              Let Joy Shine On
              </Heading>
              <div class="share-item">
                <a rel="nofollow" target="_blank" :href="facebookLink">
                  <img :src="images.shareFacebook" alt="Facebook" />
                </a>
                <a rel="nofollow" target="_blank" href="https://www.instagram.com/skjewellery_malaysia/">
                  <img :src="images.shareInstagram" alt="Instagram" />
                </a>
                <a rel="nofollow" target="_blank" href="https://www.tiktok.com/@skjewellerymalaysia/">
                  <img :src="images.shareTikTok" alt="TikTok" />
                </a>
              </div>
            </div>
          </div>

          <!-- Right Gallery for Desktop -->
          <div class="box-gallery display_flex box-gallery-pc">
            <img v-for="(image, index) in rightGallery" :key="index" :src="image.url" alt="Gallery" />
          </div>

          <!-- Right Gallery for Mobile -->
          <div class="box-gallery box-gallery-mobile">
            <img v-if="rightGalleryMobile" :src="rightGalleryMobile" alt="Gallery" />
          </div>
        </div>
      </section>
    </main>
  </template>

  <script setup lang="ts">
  import { ref } from 'vue'
  import Heading from '~/components/Heading.vue';
  import BannerButton from '~/components/Campaign/BannerButton.vue';
  import shareFacebook from '~/assets/images/review/share-face.webp'
  import shareInstagram from '~/assets/images/review/share-ins.webp'
  import shareTikTok from '~/assets/images/review/share-tiktok.jpg'

  const { $ajax } = useNuxtApp();
  const reviewData = ref();
  interface IReviewResponse {
    success: boolean;
    data: string;
  }

  // Mock data or use asyncData to fetch data
  const { pushToDataLayer, pushPageTypeToDataLayer } = useCustomGtm();
  const pageTitle = ref('');
  const bannerData = ref()
  const leftGallery = ref()
  const leftGalleryMobile = ref()
  const rightGallery = ref()
  const rightGalleryMobile = ref()
  const userStore = useUserStore();
  const route = useRoute();
  const preview = route.query.preview;
  const router = useRouter();
  import { useI18n } from 'vue-i18n';
    const { locale } = useI18n();
    let country = '';
    if (locale.value === 'ms-my') {
        country = '/ms-my';
    } else {
        country = '';
    }

  const isAuthorized = userStore.isLogin && ['administrator', 'editor'].includes(userStore.user?.role);
  const handlePostStatus = (status:string) => {
    switch (status) {
      case 'private':
        if (isAuthorized) {
          console.error('Private post accessed by an authorized user.');
        } else {
          router.push(`${country}/404/`);
        }
        break;

      case 'publish':
        break;

      case '':
        break;

      default:
        router.push(`${country}/404/`);
        break;
    }
  };


  // Social share links and images
  // const facebookLink = `https://www.facebook.com/sharer.php?u=https://www.skjewellery.com.my`
  const facebookLink = `https://www.facebook.com/SKJewellery.MY/`
  const images = {
    shareFacebook: shareFacebook,
    shareInstagram: shareInstagram,
    shareTikTok: shareTikTok,
  }


  const get_page_data = async () => {
    let page_file = '/data/review/review-page.json';
      if( preview === 'true' && userStore.isLogin && (userStore.user?.role == 'administrator' || userStore.user?.role == 'editor')){
        page_file = `/data/preview/review-preview.json`;
      }
    try {
      // const response = await $ajax.get<IHomeResponse>('data/career/gold-price.json');
        const { data: response } = await useAsyncData(
            'data',
            async () => {
              return $ajax.get<IReviewResponse>(page_file, {
                    headers: {
                    Authorization: `Bearer ${userStore.csrf}`,
                    'X-API-Server': userStore.csrf_server
                    },
                });
            },
            { immediate: true, watch: [], onError: console.error }
          );

        if (response.value && response.value.success) {
          const responseData = response.value.data;
          if (responseData) {
            pageTitle.value = responseData.page_title;
            const postStatus = responseData.status ?? '';
            handlePostStatus(postStatus);
          }
          reviewData.value = typeof responseData === 'object' ? responseData : JSON.parse(responseData);
        if (reviewData.value.banner) {
          bannerData.value = reviewData.value.banner;
        }
        if(reviewData.value.section_review && reviewData.value.section_review.enable === true){

          if(reviewData.value.section_review.left_gallery){
            leftGallery.value = reviewData.value.section_review.left_gallery
          }
          if(reviewData.value.section_review.left_gallery_mobile){
            leftGalleryMobile.value = reviewData.value.section_review.left_gallery_mobile
          }
          if(reviewData.value.section_review.right_gallery){
            rightGallery.value = reviewData.value.section_review.right_gallery
          }
          if(reviewData.value.section_review.right_gallery_mobile){
            rightGalleryMobile.value = reviewData.value.section_review.right_gallery_mobile
          }
        }

      } else {
        console.error("Invalid or empty response:", response.value);
      }
    } catch (error) {
      console.error("Error fetching campaign data:", error);
    }
  };
  get_page_data();

  const stamped = ref({
        apiKey: "67a493e9-b709-4443-8008-b3538dde4d34",
        storeUrl: "",
        storeHash: "304041",
    });

    const initializeStamped = () => {
    // Initialize Stamped widget after the script has loaded
        StampedFn.init({
            apiKey: '67a493e9-b709-4443-8008-b3538dde4d34', // Replace with your actual API key
            sId: '304041' // Replace with your actual store hash
        });
    };

    const initializeStampedWhenReady = () => {
      if (typeof StampedFn !== 'undefined') {
        initializeStamped();
        return;
      }
      window.addEventListener('stamped:script-loaded', initializeStamped, { once: true });
    };

  onMounted(() => {
      const routeslug = useRoute(); // Get the current route
      const pathSegments = routeslug.path.split('/').filter(segment => segment);
      const pageType = 'other';
      const hierachy1 = pathSegments[0] || 'n/a';
      const hierachy2 = pathSegments[1] || 'n/a';
      const hierachy3 = 'n/a';
      pushPageTypeToDataLayer(pageType, {
        hierachy1,
        hierachy2,
        hierachy3,
      });
    setTimeout(() => {
      altLazyIO();
    }, 300);
    initializeStampedWhenReady()
  })

</script>

<style lang="scss" scoped>
  @import "@/assets/scss/components/review/review.scss";
  .reviews-heading :deep .heading h2{
    margin-bottom: 20px;
  }
  .reviews-item :deep #stamped-reviews-widget[data-widget-type="full-page"] .stamped-ratings-wrapper {
      width: 100% !important;
  }
  .reviews-item :deep #stamped-reviews-widget[data-widget-type="full-page"] .stamped-widget-title {
      text-align: center;
  }
  .reviews-item :deep #stamped-reviews-widget[data-widget-type="full-page"] .stamped-widget-buttons {
      display: none !important;
  }
  .reviews-item :deep .stamped-pagination-page>a{
    color: #AD073D;
  }
</style>
